import { useMsal } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import PropTypes from "prop-types";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

const MsalEventContext = createContext({});

export const useMsalEvents = () => useContext(MsalEventContext);

export const MsalEventListener = ({ children }) => {
  const { instance } = useMsal();
  const [idToken, setIdToken] = useState(null);
  const [error, setError] = useState(null);
  const callbackIdRef = useRef(null);

  useEffect(() => {
    callbackIdRef.current = instance.addEventCallback((message) => {
      if (
        (message.eventType === EventType.LOGIN_SUCCESS ||
          message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        message.payload?.idToken
      ) {
        setIdToken(message.payload.idToken);
      } else if (
        message.eventType === EventType.LOGIN_FAILURE ||
        message.eventType === EventType.ACQUIRE_TOKEN_FAILURE
      ) {
        setError(message.error);
      }
    });
    return () => {
      if (callbackIdRef.current) {
        instance.removeEventCallback(callbackIdRef.current);
      }
    };
  }, [instance]);

  const clearIdToken = useCallback(() => setIdToken(null), []);
  const clearError = useCallback(() => setError(null), []);

  const value = useMemo(
    () => ({ idToken, error, clearIdToken, clearError }),
    [idToken, error, clearIdToken, clearError]
  );

  return (
    <MsalEventContext.Provider value={value}>
      {children}
    </MsalEventContext.Provider>
  );
};

MsalEventListener.propTypes = {
  children: PropTypes.node.isRequired,
};
